import { Link } from "react-router-dom";
import FadeUp from "./FadeUp";

export const CTASection = ({
  heading = "Ready to give yourself your time back?",
  sub = "Book a free in-home walkthrough. We'll listen, look around, and build a plan made for your home. Sarah follows up within 24 hours.",
  buttonLabel = "Book Your Free Walkthrough",
  buttonTo = "/book",
}) => (
  <section data-testid="cta-section" className="section-pad bg-navy">
    <FadeUp className="container-hh text-center">
      <h2 className="mx-auto max-w-2xl text-4xl text-white md:text-5xl">
        {heading}
      </h2>
      <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/75">
        {sub}
      </p>
      <Link
        to={buttonTo}
        data-testid="cta-section-btn"
        className="btn-teal mt-8 bg-teal text-white hover:bg-white hover:text-navy"
      >
        {buttonLabel}
      </Link>
    </FadeUp>
  </section>
);

export default CTASection;
